import { EMPTY_FIELD } from 'constants/emptyField';

import { DashboardCard } from 'pages/Dashboard/components/DashboardCard/DashboardCard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Bar } from 'react-chartjs-2';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { TransactionsDynamicSummary } from 'types/embedded/dashboard';

import { DashboardTransactionsDynamicSummarySkeleton } from './DashboardTransactionsDynamicSummarySkeleton';
import { useDashboardTransactionsDynamicSummaryChartData } from './hooks/useDashboardTransactionsDynamicSummaryChartData';
import { useDashboardTransactionsDynamicSummaryChartOptions } from './hooks/useDashboardTransactionsDynamicSummaryChartOptions';

type Props = {
  summaryPeriod: string;
  isLoading: boolean;
  summary?: TransactionsDynamicSummary;
  error?: string;
};

export const DashboardTransactionsDynamicSummary: React.FC<Props> = ({
  isLoading,
  summary,
  summaryPeriod,
  error,
}) => {
  const translate = useTypedTranslate();

  const chartData = useDashboardTransactionsDynamicSummaryChartData(summary?.items || []);

  const options = useDashboardTransactionsDynamicSummaryChartOptions(
    summary?.currency || EMPTY_FIELD,
  );

  if (isLoading) {
    return <DashboardTransactionsDynamicSummarySkeleton />;
  }

  return (
    <DashboardCard
      cardHeaderProps={{
        description: summaryPeriod,
        title: translate('app.dashboard.transactionsDynamicSummary.title'),
        sx: { paddingBottom: 0 },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '464px',
          minWidth: 0,
        }}
      >
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Bar data={chartData} options={options} />
        )}
      </Box>
    </DashboardCard>
  );
};
